import { useStyles } from './styles'
import { Avatar } from '@mui/material'
import { useTonConnectUI } from '@tonconnect/ui-react'
import WebApp from '@twa-dev/sdk'
import { goToConnectPlatform, goToTon, goToUnifiedProfile } from '@/app/routing/events'
import { LanguageSwitch } from '../langSwitch'
import { $steamId, $userLanguage } from '@/entities/user'
import { $steam } from '@/entities/platforms/store'
import { useUnit } from 'effector-react'

import { lang } from '@/shared/constants/lang'
import { Icon } from '../icon'
type HeaderProps = {
  userName?: string
  userPhotoUrl?: string
  classes?: Record<string, string | undefined>
  glowing?: boolean
  isPlusUser: boolean
}
export const Header = (props: HeaderProps) => {
  const { userPhotoUrl, userName, isPlusUser, classes: PropClasses } = props
  const { classes } = useStyles({
    classesOverrides: PropClasses,
  })

  const userLang = useUnit($userLanguage)

  const steamId = useUnit($steamId)
  const steamInfo = useUnit($steam)

  const isPlus = isPlusUser
  const tonWallet = useTonConnectUI()[0]
  const status = tonWallet.connected

  function handleGoToTonConnect() {
    if (status) {
      WebApp.showPopup({ title: '', message: lang[userLang].webappPopup.alreadyConnected })
    } else {
      goToTon()
    }
  }
  return (
    <div
      data-glowing={steamInfo.status === 'Connected'}
      className={classes.root}
    >
      <div
        onClick={() => {
          if (!steamId) {
            // return goToProfileRouter()
            return goToConnectPlatform({ platform: 'steam' })
          } else {
            return goToUnifiedProfile()
          }
        }}
        data-isplus={isPlus}
        className={classes.avatar}
      >
        <Avatar
          sx={{ width: 32, height: 32 }}
          src={userPhotoUrl}
          alt={userName}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <LanguageSwitch />
        <div
          className={classes.info}
          onClick={handleGoToTonConnect}
        >
          <Icon
            view="wallet"
            width={16}
          />
        </div>
      </div>
    </div>
  )
}
